import { powerUpSdkStrings } from "@vendata/power-up-sdk/strings";
import { powerUpCommonStrings } from "@vendata/power-up-clients-common/strings";

// BEGIN WORKFLOW AREA string-imports FOR vue/add-view sdk/add-component
import { column_select_menu } from "./components/column-select/ColumnSelectMenu.strings.ts";
import { credit } from "./pages/credit/Credit.strings.ts";
import { my_listings } from "./pages/my-listings/MyListings.strings.ts";
import { my_listings_detail } from "./pages/my-listings/detail/Detail.strings.ts";
import { my_listings_edit } from "./pages/my-listings/edit/Edit.strings.ts";
import { my_portal_empty_state } from "./pages/my-portal/MyPortalEmptyState.strings.ts";
import { my_portal_header } from "./pages/my-portal/MyPortalHeader.strings.ts";
import { my_portal_parts_table } from "./pages/my-portal/MyPortalPartsTable.strings.ts";
import { my_portal_toolbar } from "./pages/my-portal/MyPortalToolbar.strings.ts";
import { onboarding } from "./pages/onboarding/Onboarding.strings.ts";
import { parts_page } from "./pages/parts-page/PartsPage.strings.ts";
import { parts_page_detail } from "./pages/parts-page/detail/Detail.strings.ts";
import { repair } from "./pages/repair/Repair.strings.ts";
import { repair_use_credits_sheet } from "./pages/repair/RepairUseCreditsSheet.strings.ts";
import { sell_part } from "./pages/sell-part/SellPart.strings.ts";
import { credit_statement } from "./pages/credit-statement/CreditStatement.strings.ts";
import { credit_statement_header_display } from "./pages/credit-statement/CreditStatementHeaderDisplay.strings.ts";
import { credit_statement_entries_table } from "./pages/credit-statement/CreditStatementEntriesTable.strings.ts";
import { repair_detail } from "./pages/repair-detail/RepairDetail.strings.ts";
import { repair_request_display } from "./pages/repair-detail/RepairRequestDisplay.strings.ts";
import { status_updates_display } from "./pages/repair-detail/StatusUpdatesDisplay.strings.ts";
// END WORKFLOW AREA

export const power_up_app_strings = {
  // BEGIN WORKFLOW AREA string-object FOR vue/add-view sdk/add-component
  column_select_menu,
  credit,
  my_listings,
  my_listings_detail,
  my_listings_edit,
  my_portal_empty_state,
  my_portal_header,
  my_portal_parts_table,
  my_portal_toolbar,
  onboarding,
  parts_page,
  parts_page_detail,
  repair,
  repair_use_credits_sheet,
  sell_part,
  credit_statement,
  credit_statement_header_display,
  credit_statement_entries_table,
  repair_detail,
  repair_request_display,
  status_updates_display,
  // END WORKFLOW AREA

  ...powerUpSdkStrings,
  ...powerUpCommonStrings,
};
